import moment from 'moment';
import { isNil } from 'src/utils/utils';

export const concentricCircleControlEnabled =
  'concentric_circle_control_enabled_id';
export const obsRunTypes = {
  de: 0,
  eu: 8,
  benelux: 4,
  es: 14,
  fr: 16,
  ch: 18,
};
export const fcstRunTypes = {
  de: 3,
  eu: 9,
  benelux: 5,
  es: 15,
  fr: 17,
  ch: 19,
};

export const getSeason = (date?: moment.Moment): string => {
  if (!isNil(date)) {
    const month = date.month();
    // Von Mai bis September ist die Saison Sommer
    return month >= 4 && month < 9 ? 'summer' : 'winter';
  } else {
    return '';
  }
};
